import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const MedspaAesthetics = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my medspa & aesthetics business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps medspa & aesthetics businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for medspa & aesthetics businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most medspa & aesthetics businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my medspa & aesthetics business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like medspa & aesthetics. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Medspa & Aesthetics - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Medspa & Aesthetics CRM", url: "/industries/medspa-aesthetics" }
  ];

  const industryData = {
    name: 'Medspa & Aesthetics',
    title: 'Fill Your Appointment Book & Build Treatment Plan Revenue',
    subtitle: 'Automate consultation booking, send treatment reminders, and convert consultations to package purchases',
    icon: '✨',
    challenges: [
      'Consultations don\'t convert to treatments',
      'Patients don\'t complete treatment plans',
      'Last-minute cancellations cost revenue',
      'Hard to upsell additional services',
      'Membership programs underutilized'
    ],
    solutions: [
      'Consultation to treatment automation',
      'Treatment plan reminder sequences',
      'Cancellation waitlist management',
      'Service upsell campaigns',
      'Membership promotion automation'
    ],
    features: [
      'Client CRM with treatment history',
      'Online consultation booking',
      'Treatment plan tracking',
      'Appointment reminders',
      'Before/after galleries',
      'Package management',
      'Membership tracking',
      'Review automation'
    ],
    results: [
      '75% consultation conversion',
      '90% treatment plan completion',
      '50% more membership sign-ups',
      '£8.9K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Medspa & Aesthetics UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for medspa & aesthetics businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for medspa & aesthetics UK, medspa & aesthetics business software, medspa & aesthetics customer management, medspa & aesthetics lead generation UK"
        url="/industries/medspa-aesthetics"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default MedspaAesthetics;